import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { NavigationEnd, Router } from '@angular/router';

import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';

import { environment } from '@environments/environment';

import { SidenavActions, SidenavSelectors } from './store/sidenav.slice';

@Component({
  selector: 'app-sidenav',
  styleUrls: ['./sidenav.component.scss'],
  templateUrl: './sidenav.component.html',
})
export class SidenavComponent
  implements OnInit, OnDestroy, AfterContentChecked
{
  @Output() heightChanged = new EventEmitter<number>();
  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

  private subs = new SubSink();

  blogEnabled: boolean = environment.blogFeatureEnabled;
  placeholderUrl = '../../../../assets/pics/image-placeholder.png';

  merchantCount$ = this.store.select(SidenavSelectors.selectMerchantCount);

  constructor(
    public authenticator: AuthenticatorService,
    private readonly store: Store,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: Router,
    private host: ElementRef
  ) {}

  ngOnInit() {
    this.store.dispatch(SidenavActions.getMerchantCount.trigger());

    const resizeObserver = new ResizeObserver((entries) => {
      this.heightChanged.emit(entries[0].target.scrollHeight);
    });
    resizeObserver.observe(this.host.nativeElement);
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
